// @flow
import type {DataTables} from 'datatables.net';

export default function orderable(column: String, options: any,
    dtSettings: DataTables.Settings, component: JQuery) {
        dtSettings.columns.find(c => c.title == column).orderable = (options == null ? true : options);
}